import { AccountMetadata } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "adBlock"
  | "allowJsDynamicProp"
  | "chatSupport"
  | "disableMasqueradeWarningBanner"
  | "displayNewEventLibraryPage"
  | "callrailSource"
  | "experimentalDestinations"
  | "functions"
  | "geo-info"
  | "hipaa"
  | "hipaaV2"
  | "invocaSource"
  | "networkEventDefs"
  | "personas"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "sourceFunctions"
  | "sqlTransformations"
  | "traces"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI";

/**
 * Get the value of a feature flag
 */
export function getFeature(
  accountMetadata: AccountMetadata,
  featureFlag: FeatureFlag
): boolean {
  switch (featureFlag) {
    case "adBlock":
    case "allowJsDynamicProp":
    case "callrailSource":
    case "chatSupport":
    case "disableMasqueradeWarningBanner":
    case "displayNewEventLibraryPage":
    case "experimentalDestinations":
    case "functions":
    case "geo-info":
    case "hipaa":
    case "hipaaV2":
    case "invocaSource":
    case "networkEventDefs":
    case "personas":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "sourceFunctions":
    case "sqlTransformations":
    case "traces":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
